import React, { PropsWithChildren } from "react";

import ModalCloseIcon from "~/icons/ModalCloseIcon";

import styles from "./EmptyModal.module.css";
import clsx from "clsx";

type EmptyModalProps = {
  hideCloseButton?: boolean;
  visible: boolean;
  onClose: VoidFunction;
  modalClassName?: string;
};

const EmptyModal: React.FC<PropsWithChildren<EmptyModalProps>> = ({
  hideCloseButton = false,
  visible,
  onClose,
  modalClassName,
  children,
}) => {
  return visible ? (
    <div className={styles.backdrop} onClick={onClose}>
      <div
        className={clsx(styles.modal, modalClassName)}
        onClick={(e) => e.stopPropagation()}
      >
        {!hideCloseButton && (
          <div className={styles.closeButton} onClick={onClose}>
            <ModalCloseIcon />
          </div>
        )}
        {children}
      </div>
    </div>
  ) : null;
};

export default EmptyModal;
